import React from 'react';
import RestaurantSelect from '../common/RestaurantSelect';
import { Restaurant } from '../../types/api';
import Button from '../common/Button';
import { PlusIcon } from '@heroicons/react/24/outline';

interface HeaderProps {
  restaurants: Restaurant[];
  selectedRestaurantId: string | null;
  onSelectRestaurant: (restaurantId: string | null) => void;
  onAddRestaurantClick: () => void;
  isAdmin?: boolean; // Новый проп для проверки прав
}

const Header: React.FC<HeaderProps> = ({
  restaurants,
  selectedRestaurantId,
  onSelectRestaurant,
  onAddRestaurantClick,
  isAdmin = false,
}) => {
  return (
    <header className="bg-white shadow-sm border-b sticky top-0 z-30">
      <div className="px-4 py-4">
        <div className="flex items-center justify-between">
          <RestaurantSelect
            restaurants={restaurants}
            selectedRestaurantId={selectedRestaurantId}
            onSelectRestaurant={onSelectRestaurant}
            allowEmpty={true}
          />
          {isAdmin && (
            <Button 
              onClick={onAddRestaurantClick} 
              variant="secondary"
              className="flex items-center space-x-2 ml-4"
            >
              <PlusIcon className="w-4 h-4" />
              <span>Добавить ресторан</span>
            </Button>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;
